import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSubscription } from '../contexts/SubscriptionContext';

/**
 * Drop-in replacement for `<Link>` that gates navigation behind an
 * active subscription. If the user is not logged in, redirects to /login.
 * If logged in but not subscribed, opens the global premium-gate modal
 * over the current page (no navigation). Subscribers and admins navigate
 * normally.
 */
export default function PremiumLink({ to, onClick, children, ...rest }) {
  const sub = useSubscription();
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (onClick) onClick(e);
    if (e.defaultPrevented) return;

    // Let modifier-clicks (open in new tab/window) behave normally.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;

    // /read/* paths support a guest preview — the Reader fetches the
    // public /api/books/:id/preview (cover + first 3 content pages)
    // and opens the paywall gate itself when the visitor reaches the
    // last preview spread. So navigate unconditionally and let the
    // Reader handle gating downstream.
    if (typeof to === 'string' && to.startsWith('/read/')) {
      e.preventDefault();
      navigate(to);
      return;
    }

    e.preventDefault();
    const token = localStorage.getItem('adeeb-token');
    if (!token) {
      navigate(`/login?next=${encodeURIComponent(to)}`);
      return;
    }
    if (sub.active) {
      navigate(to);
    } else {
      sub.openGate(to);
    }
  };

  return (
    <Link to={to} onClick={handleClick} {...rest}>
      {children}
    </Link>
  );
}
